import { clsx } from "clsx";
import { type FC, type PropsWithChildren, useContext, useRef } from "react";
import { type AriaRadioProps, useFocusRing, useRadio, VisuallyHidden } from "react-aria";

import formStyle from "../../styles/form.module.css";
import styleLabel from "../Label/Label.module.css";
import { VStack } from "../Stack/VStack.tsx";
import style from "./Radio.module.css";
import { RadioContext } from "./settings.ts";

interface RadioProps extends AriaRadioProps {
  description?: string;
}

export const Radio: FC<PropsWithChildren<RadioProps>> = (props) => {
  const state = useContext(RadioContext);
  const ref = useRef<HTMLInputElement>(null);
  const { inputProps, isSelected, isDisabled } = useRadio(props, state, ref);
  const { isFocusVisible, focusProps } = useFocusRing();

  return (
    <label className={clsx(style.input, { [style.disabled]: isDisabled })}>
      <VisuallyHidden>
        <input {...inputProps} {...focusProps} ref={ref} />
      </VisuallyHidden>
      <div
        className={clsx(style.radio, {
          [style.selected]: isSelected,
          [style.focus]: isFocusVisible,
          [style.error]: state.isInvalid,
        })}
      />
      <VStack spacing={0}>
        <div className={styleLabel.label}>{props.children}</div>
        {props.description != undefined && <div className={formStyle.description}>{props.description}</div>}
      </VStack>
    </label>
  );
};
